import React, { useState } from 'react';

const PARALINGUISTIC_TAGS = [
  '[clear throat]',
  '[sigh]',
  '[shush]',
  '[cough]',
  '[groan]',
  '[sniff]',
  '[gasp]',
  '[chuckle]',
  '[laugh]',
];

function ParalinguisticTags({ textareaRef, formData, setFormData }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const insertTagAtCursor = (tag) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = formData.text;
    const newText = text.substring(0, start) + tag + text.substring(end);

    setFormData({
      ...formData,
      text: newText,
    });

    // Restore focus and move cursor after the tag
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + tag.length, start + tag.length);
    }, 0);

    // Close the tags panel after inserting
    setIsExpanded(false);
  };

  return (
    <div className="tags-section">
      <button
        type="button"
        className="tags-toggle-button"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        Tags
        <span className={`tags-toggle-icon ${isExpanded ? 'expanded' : ''}`}>▼</span>
      </button>

      {isExpanded && (
        <div className="tags-grid">
          {PARALINGUISTIC_TAGS.map((tag) => (
            <button
              key={tag}
              type="button"
              className="tag-button"
              onClick={() => insertTagAtCursor(tag)}
              title={`Insert ${tag}`}
            >
              {tag}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ParalinguisticTags;
